<script>
    let currentYear = new Date().getFullYear();
    export let onClick;
</script>

<nav class="social-nav">
    <a href="https://github.com/JoshuaZheng0/" target="_blank" class="icon-container">
        <img src="/assets/icons/github-mark-white.svg" alt="GitHub Icon" class="icon" />
        <span class="icon-label">GitHub</span>
    </a>
    <a href="https://www.linkedin.com/in/joshzheng7/" target="_blank" class="icon-container">
        <img src="/assets/icons/linkedin-icon-white.svg" alt="LinkedIn Icon" class="icon" />
        <span class="icon-label">LinkedIn</span>
    </a>
    <a on:click={onClick} class="icon-container">
        <img src="/assets/icons/email.png" alt="Email Icon" class="icon-terplink" />
        <span class="icon-label">Email</span>
    </a>
</nav>

<style>
    .social-nav {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 2rem;
        padding: 2rem;
        margin: 2rem 0;
    }

    .icon-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.5rem;
        padding: 1rem;
        border-radius: 12px;
        text-decoration: none;
        color: #e0e0e0;
        transition: all 0.3s ease;
        background: rgba(255, 255, 255, 0.05);
        border: 1px solid rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        min-width: 80px;
    }

    .icon-container:hover {
        background: rgba(100, 181, 246, 0.1);
        border-color: rgba(100, 181, 246, 0.3);
        transform: translateY(-4px);
        color: #64b5f6;
    }

    .icon, .icon-terplink {
        width: 32px;
        height: 32px;
        object-fit: contain;
        transition: transform 0.3s ease;
    }

    .icon-container:hover .icon,
    .icon-container:hover .icon-terplink {
        transform: scale(1.1);
    }

    .icon-label {
        font-size: 0.8rem;
        font-weight: 500;
        text-align: center;
        transition: color 0.3s ease;
    }

    @media only screen and (max-width: 768px) {
        .social-nav {
            gap: 1rem;
            padding: 1rem;
            margin: 1rem 0;
        }

        .icon-container {
            padding: 0.75rem;
            min-width: 70px;
        }

        .icon, .icon-terplink {
            width: 28px;
            height: 28px;
        }

        .icon-label {
            font-size: 0.75rem;
        }
    }

    @media only screen and (max-width: 480px) {
        .social-nav {
            gap: 0.5rem;
        }

        .icon-container {
            padding: 0.5rem;
            min-width: 60px;
        }

        .icon, .icon-terplink {
            width: 24px;
            height: 24px;
        }

        .icon-label {
            font-size: 0.7rem;
        }
    }
</style>